import { render, staticRenderFns } from "./garden12.vue?vue&type=template&id=3acd8996&scoped=true&"
import script from "./garden12.vue?vue&type=script&lang=js&"
export * from "./garden12.vue?vue&type=script&lang=js&"
import style0 from "./garden12.vue?vue&type=style&index=0&id=3acd8996&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acd8996",
  null
  
)

export default component.exports